import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTimer = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 0.906647C7.70542 0.906647 7.46664 1.14542 7.46664 1.43998V3.75717C7.46664 4.05172 7.70542 4.2905 7.99998 4.2905C8.29453 4.2905 8.53331 4.05172 8.53331 3.75717V1.99659C11.6119 2.26654 14.0267 4.85127 14.0267 7.99998C14.0267 11.3284 11.3284 14.0267 7.99998 14.0267C4.67154 14.0267 1.97331 11.3284 1.97331 7.99998C1.97331 6.5132 2.51101 5.15337 3.40319 4.1023C3.5938 3.87774 3.56628 3.54118 3.34172 3.35057C3.11716 3.15995 2.7806 3.18747 2.58998 3.41203C1.54032 4.64862 0.906639 6.25098 0.906639 7.99998C0.906639 11.9176 4.08243 15.0933 7.99998 15.0933C11.9175 15.0933 15.0933 11.9176 15.0933 7.99998C15.0933 4.08244 11.9175 0.906647 7.99998 0.906647ZM7.18985 8.61944L4.5052 4.8772C4.42913 4.77115 4.44102 4.62563 4.53331 4.53334C4.62559 4.44105 4.77112 4.42916 4.87716 4.50523L8.6194 7.18988C9.13309 7.55839 9.19366 8.29964 8.74664 8.74667C8.29961 9.1937 7.55837 9.13311 7.18985 8.61944Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTimer)
const IconSvgTimer = createIcon(ForwardRef, 'SvgTimer')
export default IconSvgTimer
